import React, { useState } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import * as Dropdown from 'components/Dropdown';
const error = 'Select a Variable';
const DropdownComponent = props => {
  const [classForError, setClassForError] = useState('hide');

  const handleOnMouseEnter = () => setClassForError('visible');
  const handleOnMouseLeave = () => setClassForError('hide');

  return (
    <div className={`main-dropdown mb-15 ${props.isError ? 'two-lines has-error' : ''}`}>
      <p className={
        props.labelClassName ? props.labelClassName : 'main-dropdown__label'}
      >
        {props.label}
      </p>
      {props.isError &&
        <>
          <i
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
            className="icon icon-alert-triangle"
          />
          <span
            className={`main-tooltip main-input-tooltip ${classForError}`}
          >{error}
          </span>
        </>
      }
      <Field
        component={Dropdown.ReduxFormWrapper}
        options={props.optionsList}
        {...props}
      />
    </div>
  );
};

DropdownComponent.propTypes = {
  label: PropTypes.string.isRequired,
  optionsList: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  isError: PropTypes.bool,
  error: PropTypes.string
};

export default DropdownComponent;
